import Divider from '@mui/material/Divider';
import Container from 'components/Container';
import Main from 'layouts/Main';
import React from 'react';
import { Helmet } from 'react-helmet';
import {
  Application,
  Contact,
  Hero,
  Services,
  Story,
  Team,
  WhoWeAre,
} from './components';

const About = () => {
  return (
    <Main colorInvert={true}>
      <Helmet>
        <title>About Us - Topibro Technologies</title>
      </Helmet>
      <Hero />
      <Container>
        <Story />
      </Container>
      <Container paddingTop={'0 !important'}>
        <WhoWeAre />
      </Container>
      <Container>
        <Services />
      </Container>
      <Container maxWidth={800} paddingY={'0 !important'}>
        <Divider />
      </Container>
      <Container>
        <Team />
      </Container>
      {/* <Box bgcolor={'alternate.main'}>
        <Container>
          <Partners />
        </Container>
      </Box> */}
      <Contact />
      {/* <Container>
        <Gallery />
      </Container> */}
      <Container maxWidth={800}>
        <Application />
      </Container>
    </Main>
  );
};

export default About;
